// Libraries
var React = require('react');
var PubSub = require('pubsub-js');

// Components
var InPageTabsBar = require('./InPageTabsBar');

// Styles
require('./InPageTabsModule.scss');

class InPageTabsModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			tabs: this.props.data.links.map((item) => {
				item.isLoaded = item.preload || item.isSelected || false;
				item.hasIndicator = false;
				return item;
			}),
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null,
			matchDetailMParticleEventObject: (typeof window !== "undefined" && window.matchDetailMParticleEventObject) ? window.matchDetailMParticleEventObject  : null
		};

		PubSub.subscribe('IndicatorChange', this.indicatorChangeHandler);
	};

	replaceDetailsType(type) {

		if (type === 'Commentary') return 'commentary';
		if (type === 'LatestNews') return 'latest_news';
		if (type === 'LineUp') return 'lineups';
		if (type === 'Stats') return 'stats';
		if (type === 'LiveResults') return 'live_results';
		if (type === 'Betting') return 'betting';

		return type.toLowerCase();

	}

	handleMParticleTracking(type) {

		if (
			this.state.defaultMParticleEventObject !== null &&
			this.state.matchDetailMParticleEventObject !== null
		) {

			const eventDataMerged = {...this.state.defaultMParticleEventObject, ...this.state.matchDetailMParticleEventObject };
			eventDataMerged.details_type = this.replaceDetailsType(type);
			window.dataLayer.push(eventDataMerged);

		}

	}

	componentDidMount() {
		const bettingTab = this.props.data.links.find(link => link.tabId === 'Betting');

		if (bettingTab) {
			// poll for DY script loaded
			const DYPoll = setInterval(() => {
				if (window.DY && window.DY.API && bettingTab.isLoaded) {
					window.DY.API('spa', {
						context: window.DY.recommendationContext,
					});

					this.setState({
						bettingLoaded: true,
					});

					clearInterval(DYPoll);
				}
			});
		}
	}

	handleClick = (event, tabIndex) => {

		// We only handle the click when in async mode.
		if (!this.props.data.isAsync) return true;

		if (this.props.data.links[tabIndex].url === null) {
			event.preventDefault();

			let newTabs = this.state.tabs.slice();
			newTabs.map((item) => {
				item.isSelected = false;
				item.hasIndicator = false;
				return item;
			});

			newTabs[tabIndex].isSelected = true;
			newTabs[tabIndex].isLoaded = true;
			
			this.setState({
				tabs: newTabs
			}, () => {
				window.LazyLoad.concat();

				if (newTabs[tabIndex].tabId === 'Betting' && !this.state.bettingLoaded) {
					window.DY.API('spa', {
						context: window.DY.recommendationContext,
					});

					this.setState({
						bettingLoaded: true,
					});
				}
			});

			this.handleMParticleTracking(newTabs[tabIndex].tabId);

			this.updateTabQueryString(newTabs[tabIndex].tabId);
		}
	};

	updateTabQueryString = tab => {
		window.history.replaceState({}, '', `${window.location.pathname}?tab=${tab}`);
	};

	indicatorChangeHandler = (message, data) => {
		let tabs = this.state.tabs.slice();
		let tab = tabs.find(x => x.tabId === data.tabId);

		if(tab && !tab.isSelected) {
			tab.hasIndicator = data.hasIndicator;
		}

		this.setState({ tabs: tabs });
	}

	render() {
		const additionalInPageTabsClass = this.props.data.isOneHotspur ? 'c-in-page-tabs--one-hotspur' : '';

		return (
			<div className={`${additionalInPageTabsClass}`}>
				<div className="InPageTabs">
					<InPageTabsBar tabs={this.state.tabs} handleClick={this.handleClick}/>
				</div>

				{this.props.data.isAsync && this.props.data.links.length > 0 &&
					this.state.tabs.map((item, index) => { return(
						<div className="InPageTabs__async" key={index} style={{display: item.isSelected ? "block" : "none"}}>
							{item.isLoaded &&
								<div className="InPageTabs__async__content" tabIndex="0">
									{item.modules.length > 0 &&
										item.modules.map((module, index) => {
											return React.createElement(window.Components[module.name], {"key": index, "data": module.data, "tabId": item.tabId });
										})
									}
								</div>
							}
						</div>
					)})
				}
			</div>
		)
	}
}

module.exports = InPageTabsModule;



// WEBPACK FOOTER //
// ./src/components/Navigation/InPageTabs/InPageTabsModule.js